import React, { memo } from 'react';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './verdict-skeleton.scss';

export const VerdictSkeleton = memo(() => (
  <div className="verdict-skeleton mb-1_5">
    <Skeleton className="d-block height-22 rounded-6 w-100 mb-0_5" />
    <Skeleton className="d-block height-22 rounded-6 w-100 mb-0_5" />
    <Skeleton className="d-block height-22 rounded-6 w-40 mb-0_5" />
    <Skeleton className="d-block height-22 rounded-6 w-30 mb-0_5" />
  </div>
));

VerdictSkeleton.displayName = 'VerdictSkeleton';
